import { initCardUserInfo } from '../utils/avatar'
import { handleLogin } from '@/utils/mutiple.js'
import { getItem } from '@/utils/storage-main.js'
import router from '@/router'
import { Scheme, NotBindPhoneNames } from '@/constant'
import { getBusinessType } from '@/constant'

// 新版跳转
async function handleFinalJump() {
  try {
    // 生成用户头像
    // 待定点： 可以后置，用户人群的新旧，后续增量情况考虑
    if (!getBusinessType().isNeedSkipGenerateAvatar) {
      await initCardUserInfo()
    }
    // 登录/注册、 游客登录注册
    const businessName = getItem('business')
    handleLogin(businessName)
  } catch (error) {
    console.log(error)
  }
}
// 拦截补充个人信息
const noHandleScheme = new Set(['cim']);
const handleScheme = (error) => {
  if (error.code === 50 && Scheme.includes(error.data.scheme)) {
    // 处理CIM 不需要补充个人信息.
    if (noHandleScheme.has(localStorage.getItem('business'))) {
      return
    }
    const name = getItem('business')

    if (NotBindPhoneNames.includes(name)) return
    router.push({
      path: '/personalInfo',
      query: {
        ...router.currentRoute.query
      },
    })
  }
}

export { handleFinalJump, handleScheme }
